import { Component, OnInit, ViewChild } from '@angular/core';
import { IonModal, ModalController } from '@ionic/angular';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { UserFormComponent } from '../user-form/user-form.component';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { User } from 'src/app/micro-services/user/models/user';
import { ClientService } from 'src/app/services/client-service.service';
import { UserEleve } from 'src/app/micro-services/user/models/user-eleve';


@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss'],
})
export class ListUserComponent implements OnInit {

  @ViewChild(IonModal) modal: IonModal;
  users: User[] = [];
  actifUsers: User[] = [];
  inactifUsers: User[] = [];
  isEdit: boolean;
  title : string;
  userEdit : User;
  searchTerm$ = new Subject<string>();
  filteredClients: User[] = [];
  client : User;
  isInactive: boolean = false;
  coachId : string;


  constructor(
    private userService: UserService,
    private  ApiProviderService: ApiProviderService,
    private modalCtrl : ModalController,
    private router : Router,
    private clientService: ClientService,
  ) { }

  ngOnInit() {
    let coach = this.userService.getUser();
    this.coachId = coach.id;
    
    // Initial retrieval of clients
    this.getClients(this.coachId);
    // Subscribe to the observable for real-time updates
    this.clientService.clients$.subscribe((updatedClients) => {
      // Handle real-time updates here
      this.actifUsers = updatedClients.filter(client => client.isActive);
      this.inactifUsers = updatedClients.filter(client => !client.isActive);
      // Update filteredClients based on isActive state
      this.filteredClients = this.isInactive ? [...this.inactifUsers] : [...this.actifUsers];
    });
  }


  addNewUser(user : string){
    let u : User = JSON.parse(user)
    this.users.push(u);
  }

  toggleStatus( isActiveList : string) {
    if(isActiveList == "Inactif"){
      this.isInactive = true;
      this.filteredClients = this.inactifUsers
    }else{
      this.isInactive = false;
      this.filteredClients = this.actifUsers
    }
    
  }

    //Modal 
  
    cancel() {
      this.modal.dismiss(null, 'cancel');
    }

    async openModal(title : string) {
      const modal = await this.modalCtrl.create({
        component: UserFormComponent,
        componentProps:{foo: this.userEdit,
        title : title}
      });
      modal.present();
  
      const { data, role } = await modal.onWillDismiss();

      if (role === 'confirm') {
        this.getClients(this.coachId)
      }
      this.userEdit = null;
    }

    search(event: any): void {
      const searchTerm = event.detail.value;
      this.searchTerm$.next(searchTerm);
      this.filterClients(searchTerm)
    }

    goToClientPage(client: User) {
      try {
        this.client = client;
        this.userService.selectedClient = this.client;
        this.router.navigate(['/coach/client']);
      } catch (error) {
        // Gestion de l'erreur
        console.error('Une erreur s\'est produite lors de la navigation vers la page du client :', error);
        // Afficher un message d'erreur à l'utilisateur ou prendre d'autres mesures appropriées
      }
    }
  
    filterClients(searchTerm: string): void {
      if (this.filteredClients) {
        this.filteredClients = this.isInactive ? [...this.inactifUsers] : [...this.actifUsers];
        if (searchTerm) {
          const lowerCaseTerm = searchTerm.toLowerCase();
    
          this.filteredClients = this.filteredClients.filter(
            (client) =>
              client.userName?.toLowerCase().includes(lowerCaseTerm) ||
              client.name?.toLowerCase().includes(lowerCaseTerm) ||
              client.firstName?.toLowerCase().includes(lowerCaseTerm)
          );
        }
      }
    }

    getClients(coachId: string) {
      this.ApiProviderService.getUsersByCoach(coachId).subscribe(
        (res) => {
          const updatedClients: UserEleve[] = [];
          res.forEach((client : UserEleve) => {
            if (client.isActive) {
              if (!this.isClientInList(client, this.actifUsers)) {
                this.actifUsers.push(client);
              }
            } else {
              if (!this.isClientInList(client, this.inactifUsers)) {
                this.inactifUsers.push(client);
              }
            }
            updatedClients.push(client);
          });
  
          // Update filteredClients based on isActive state
          this.filteredClients = this.isInactive ? [...this.inactifUsers] : [...this.actifUsers];
  
          // Use the service to update the clients list
          this.clientService.updateClients(updatedClients);
        },
        (err) => {
          this.users = [];
        }
      );
    }
    
    isClientInList(client: any, userList: any[]): boolean {
      return userList.some((user) => user.id === client.id);
    }
}
